module.exports = __webpack_public_path__ + "fonts/7272116.eot";